import { useContext, useEffect, useState } from "react";

import PsContext from "../../context";
import HomeSlider from "./homeSlider";
import { SuperSEO } from "react-super-seo";
import { _HOME_PAGE_SETTINGS } from "../../models/fieldSettings";
import { lowerCase } from "../../utils";
import AnnouncementBox from "./announcements";
import HomeAboutUsPage from "./homeAboutUsPage";
import WelcomeBanner from "./welcomeBanner";
import Events from "./event";
import TestimonialsList from "./testimonialsList";
import HomeGallery from "../galleryList/homeGallery";
import SearchPage from "../defaultLayout/header/SearchPage";

const HomePage = (props) => {
  const context = useContext(PsContext);
  const [showSearch, setShowSearch] = useState(false);

  const [homePageSettings, setHomePageSettings] = useState([]);

  useEffect(() => {
    _HOME_PAGE_SETTINGS().then((res) => {
      if (res.status == "1") {
        setHomePageSettings(res.data);
      } else {
        console.log("Error on loading home page settings..");
      }
    });
  }, []);

  const checkComponentActive = (compId) => {
    let m = homePageSettings.find(
      (item) => lowerCase(item.component_id) == lowerCase(compId)
    );
    return m && m.show_on_site == "1" ? true : false;
  };

  const componentContent = (compId) => {
    let m = homePageSettings.find(
      (item) => lowerCase(item.component_id) == lowerCase(compId)
    );
    if (m && m.show_on_site == "1") {
      if (m && m.component_filter) {
        let jv = m.component_filter;
        if (jv && jv.length > 3) {
          let x = JSON.parse(jv.trim());
          return x;
        }
      }
    }
    return [];
  };

  return (
    <div>
      <SuperSEO
        title={context.settingValue("web_site_name")}
        description={
          context.settingValue("web_site_meta_description") ||
          "Aditanar College"
        }
        keywords={
          context.settingValue("web_site_meta_keyword") || "Aditanar College"
        }
        lang="en"
        openGraph={{
          ogTitle:
            context.settingValue("web_site_name") ||
            "Dr.Sivanthi Aditanar College",
          ogDescription:
            context.settingValue("web_site_meta_description") ||
            "Dr.Sivanthi Aditanar College",
        }}
      />

      {homePageSettings && (
        <>
          {checkComponentActive("home_slider_wide") && (
            <HomeSlider dataSource={componentContent("home_slider_wide")} />
          )}

          <div className="container mt-4">
            <div className="row">
              <div
                className="col-md-8"
                style={{
                  borderRight: "1px solid #eee",
                }}
              >
                {checkComponentActive("home_about_us") && (
                  <HomeAboutUsPage
                    dataSource={componentContent("home_about_us")}
                  />
                )}

                {checkComponentActive("home_vision_mission") && (
                  <HomeAboutUsPage
                    dataSource={componentContent("home_vision_mission")}
                  />
                )}

                {checkComponentActive("home_facilities") && (
                  <HomeAboutUsPage
                    dataSource={componentContent("home_facilities")}
                  />
                )}
                {checkComponentActive("home_admin_message") && (
                  <HomeAboutUsPage
                    dataSource={componentContent("home_admin_message")}
                  />
                )}
              </div>
              <div className="col-md-4 mt-5">
                <div className="sidebar-box">
                  <div
                    className="search-bar d-flex mb-3"
                    onClick={() => setShowSearch(true)}
                  >
                    <input
                      type="text"
                      className="form-control search-input"
                      placeholder="Enter your search"
                    />
                    <button className="search-btn">
                      <i className="fas fa-search"></i>
                    </button>
                  </div>

                  {/*  <div className="logo-box text-center mb-3">
                    <img
                      src="https://portal.aei.edu.in/files_list/aei/drsacoe/fm/website/home/sacelogo.png"
                      alt="College Logo"
                      className="img-fluid logo-img"
                    />
                  </div> */}

                  <div className="logo-box text-center mb-3">
                    <AnnouncementBox />
                  </div>

                  <div className="logo-box text-center mb-3">
                    <Events />
                  </div>

                  <div className="logo-box-noh text-center mb-3">
                    <TestimonialsList />
                  </div>

                  <div className="logo-box-noh text-center mb-3">
                    <HomeGallery />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {checkComponentActive("home_faq") && (
            <HomeAboutUsPage dataSource={componentContent("home_faq")} />
          )}

          {checkComponentActive("home_institution") && (
            <HomeAboutUsPage
              dataSource={componentContent("home_institution")}
            />
          )}

          {showSearch && <SearchPage onClose={() => setShowSearch(false)} />}
          <WelcomeBanner />
        </>
      )}
    </div>
  );
};

export default HomePage;
